module.exports = __webpack_public_path__ + "img/FR12779.c8606788.png";